import { Button } from "antd";
import { get } from "lodash";
import querystring from "querystring";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { getQueryString, isMobile } from "../../utils/common";
import axios from "../../utils/selfRequest";
import { language } from "@/utils/language"; 
import "./index.less";
// 测试页
export default function LimitAnswer(props) {
  const { showStr, surveyInfo } = props

  return (
    <div className="testlist-layout">
      <div className="layout-header">
        <div className="survey-title"  style={{ color: surveyInfo.themeColor }}>
        {language().end}
        </div>
      </div>
      <div className="layout-body">
        <div className="question-content">
          <div className="base-checkbox" style={{ minHeight: "85vh" }}>
            <div className="q-content">
            <div style={{textAlign: 'center'}}>
              <span>{showStr}</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
